<template>
    <BCard>
        <BRow>
            <BCol cols="12">
                <h4 class="mb-2">{{ $t("General data") }}</h4>
            </BCol>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Address" :vsValue="teacher.address" vsXlLabel="6" vsXlValue="6" />
                </table>
            </BCol>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="teacher.phone" vsXlLabel="6" vsXlValue="6" />
                </table>
            </BCol>
            <BCol cols="12" class="mt-2" v-if="teacher.observations">
                <div class="col-12 mb-1 title p-0 font-weight-bold">
                    <FeatherIcon icon="InfoIcon" class="mr-75" />
                    <span>{{ $t('Observations') }}</span>
                </div>
                <div class="col-12 p-0"> {{ teacher.observations }} </div>
            </BCol>
        </BRow>
    </BCard>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue';
import { inject } from '@vue/composition-api';
import ViewData from '@/components/ViewData.vue';

export default {
    components: { BCard, BRow, BCol, ViewData },
    setup(){
        const teacher = inject('teacher')

        return {
            teacher,
        }
    }
}
</script>
<style lang="scss">
    @import 'src/assets/scss/variables/_variables.scss';
    table tr th, .title {
        color: $primary;
    }

    table tr th span, .title {
        text-transform: uppercase;
    }
</style>